import {
  dashboard,
  systemEvents,
  validation,
  myDonations,
  explore,
  onDemandSub,
  multiCause,
  successStories,
  trending,
  featuredCampaigns,
} from '../../services/apiVariable';
import { apiCall, apiEventCall } from '../../services/api';
import {
  getUrlParams,
  getDecodedCookies,
  getLocalData,
  isObjEmpty,
  getUserClevertapData,
} from '../../services/helperFunctions';
import { getCookie } from '../../services/utilities';

export const getProfile = (context, setContext) => new Promise((resolve, reject) => {
  if (isObjEmpty(context)) {
    apiCall({ ...dashboard.getProfile })
      .then(async (res) => {
        const claverTapData = getUserClevertapData(res.data.data);
        localStorage.setItem('userdata', JSON.stringify(res.data.data));
        systemEvents.sendEvent.entity_id = res.data.data.id;

        if (res.status === 200) {
        // Set Identity of user
          window.clevertap.onUserLogin.push(claverTapData);
          setContext(res.data.data);
          resolve(res.data.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    localStorage.setItem('userdata', JSON.stringify(context));
    resolve(context);
  }
});

export const getPortfolio = (subId, cause) => new Promise((resolve, reject) => {
  dashboard.getPortfolio.subId = subId;
  dashboard.getPortfolio.cause = cause;
  apiCall({ ...dashboard.getPortfolio })
    .then((res) => {
      if (res.status === 200) {
        localStorage.setItem('latestorder', JSON.stringify(res.data.data));
        resolve(res.data.data);
        const { wallet_balance } = JSON.parse(localStorage.getItem('userdata'));
        if (res.data.data.payment_mode === 'KETTO_WALLET' && res.data.data.amount > wallet_balance.balance && res.data.data.currency == 'inr') {
          localStorage.setItem('pledgeActive', false);
        } else {
          localStorage.setItem('pledgeActive', res.data.data.isPledgeEnable);
        }
        localStorage.setItem('sipAmount', res.data.data.amount);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const getSubscription = (count, setCount) => new Promise((resolve, reject) => {
  if (isObjEmpty(count)) {
    apiCall({ ...dashboard.getSubscription })
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data.data.data);
          setCount(res.data.data.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    resolve(count);
  }
});

export const getCertificate = (orderId) => new Promise((resolve, reject) => {
  dashboard.getCertificate.orderId = orderId;
  
  apiCall({ ...dashboard.getCertificate })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const activateRewards = (id, body) => new Promise((resolve, reject) => {
  dashboard.optRewards.entityId = id;
  
  apiCall({ ...dashboard.optRewards, body })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      reject(err);
    });
});
export const getProfileInfo = () => new Promise((resolve, reject) => {
  apiCall({ ...dashboard.getProfileInfo })
    .then((res) => {
      //  dispatch({ type: homeStore.viewAllWallDetails, payload: res.data.data })
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const getImpactInfo = () => new Promise((resolve, reject) => {
  apiCall({ ...dashboard.getImpactInfo })
    .then((res) => {
      //  dispatch({ type: homeStore.viewAllWallDetails, payload: res.data.data })
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const sendEvents = (
  entity_type = '',
  page_name = '',
  info_1 = '',
  info_3 = '',
  info_2 = '',
  isCt = false,
  info_4 = '',
  ab_testname = '',
  reward_name = '',
  from_donate = false,
) => new Promise((resolve, reject) => {
  // systemEvents.sendEvent.entityType = entity_type;
  systemEvents.sendEvent.eventName = entity_type;
  systemEvents.sendEvent.page_name = page_name;
  systemEvents.sendEvent.info_1 = info_1;
  systemEvents.sendEvent.info_3 = info_3;
  systemEvents.sendEvent.info_2 = info_2;
  systemEvents.sendEvent.info_4 = info_4;
  systemEvents.sendEvent.referrer_page = document.referrer;

  const hasParameters = getUrlParams();
  const hasParamCookie = getDecodedCookies('k_utm');
  const isAppUser = getCookie('platform');
  
  window.VWO = window.VWO || [];
  let ab = {
    abtestname: '',
    abvalue: '',
  };

  if (isAppUser) {
    systemEvents.sendEvent.platform = isAppUser;
  }

  if (typeof window.VWO !== 'undefined') {
    /** WHen user is part of AB then this event will fire */
    /* eslint no-underscore-dangle: 0 */
    if (
      typeof window._vwo_exp !== 'undefined'
        && Object.keys(window._vwo_exp).length
    ) {
      window.VWO.push([
        'onEventReceive',
        'vA',
        (expData) => {
          const experimentId = expData[1]; // To fetch A/B test id
          const variationId = expData[2]; // To fetch A/B test active variation name
          /* eslint no-underscore-dangle: 0 */
          ab = {
          /* eslint no-underscore-dangle: 0 */
            abtestname: window._vwo_exp[experimentId].name || '',
            /* eslint no-underscore-dangle: 0 */
            abvalue: window._vwo_exp[experimentId].comb_n[variationId] || '',
          };
          sessionStorage.setItem('ab_item', JSON.stringify(ab));
        },
      ]);
    }
  }
  systemEvents.sendEvent.ab_testname = ab.abtestname || '';
  systemEvents.sendEvent.ab_value = ab.abvalue || '';

  if (Object.entries(hasParameters).length > 0) {
    // Set data if url has params
    Object.entries(hasParameters).map((entry) => {
      systemEvents.sendEvent[entry[0]] = entry[1];
    });
    apiEventCall({ ...systemEvents.sendEvent })
      .then((res) => {
        resolve(res);
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  } else if (Object.entries(hasParamCookie).length > 0) {
    // Check if cookie and data exists
    Object.entries(hasParamCookie).map((entry) => {
      systemEvents.sendEvent[entry[0]] = entry[1];
    });
    apiEventCall({ ...systemEvents.sendEvent })
      .then((res) => {
        resolve(res);
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    apiEventCall({ ...systemEvents.sendEvent })
      .then((res) => {
        resolve(res);
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  }

  if (isCt) {
    const data = {};
    data.entity_type = entity_type;
    data.page_name = page_name;
    data.info_1 = info_1;
    data.info_3 = info_3;
    data.info_2 = info_2;
    data.info_4 = info_4;
    data.reward_name = reward_name;
    
    if (systemEvents.sendEvent.platform) {
      data.platform = systemEvents.sendEvent.platform;
    }
    // Check it url has utm params and set if yes
    if (systemEvents.sendEvent.utm_source) {
      data.utm_source = systemEvents.sendEvent.utm_source;
      data.utm_campaign = systemEvents.sendEvent.utm_campaign;
      data.utm_medium = systemEvents.sendEvent.utm_medium;
    }

    // if (Object.entries(hasParameters).length > 0) { // Check if cookie and data exists
    //   Object.entries(hasParameters).map((entry) => {
    //     data[entry[0]] = entry[1];
    //   });
    // }

    handleCtEvents(data, from_donate || false);
  }
});

export const handleCtEvents = async (data, from_donate) => {
  const CtData = {};
  const userData = await getLocalData('userdata');
  CtData.entity_type = data.entity_type;
  CtData.page_name = data.page_name;
  CtData.info_1 = data.info_1;
  CtData.info_3 = data.info_3;
  CtData.info_2 = data.info_2;
  CtData.info_4 = data.info_4;
  CtData.Identity = userData.id;
  CtData.id = userData.id;
  CtData.email = userData.email;
  CtData.Mobile = userData.phone_1;
  CtData.platform = data.platform
    ? data.platform
    : document.body.clientWidth < 500
      ? 'Mweb'
      : 'Web';
  if (data.reward_name) CtData.reward_name = data.reward_name.replace('_', ' ');
  // console.log(clevertap, { ...systemEvents });
  window.clevertap.event.push(data.entity_type, !from_donate ? { ...CtData } : { ...CtData, ...from_donate });
};

export const getDonation = (currency, summary, setSummary) => new Promise((resolve, reject) => {
  dashboard.getDonation.currency = currency;
  if (isObjEmpty(summary)) {
    apiCall({ ...dashboard.getDonation })
      .then((res) => {
      //  dispatch({ type: homeStore.viewAllWallDetails, payload: res.data.data })
        if (res.status === 200) {
          setSummary(res.data.data);
          resolve(res.data.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    resolve(summary);
  }
});

export const verifySipUser = (id) => new Promise((resolve, reject) => {
  validation.validateSipUser.entityId = id;
  apiCall({ ...validation.validateSipUser })
    .then((res) => {
      //  dispatch({ type: homeStore.viewAllWallDetails, payload: res.data.data })
      // resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const updatePayment = (id) => new Promise((resolve, reject) => {
  dashboard.resumeGiving;
  apiCall({ ...validation.re })
    .then((res) => {
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const getMyDonations = (id, page) => new Promise((resolve, reject) => {
  myDonations.getMyDonations.entityId = id;
  myDonations.getMyDonations.page = page || 1;
  apiCall({ ...myDonations.getMyDonations })
    .then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const requestRefund = (campId, orderId, body) => new Promise((resolve, reject) => {
  myDonations.requestRefund.campId = campId;
  myDonations.requestRefund.orderId = orderId;
  myDonations.requestRefund.body = body;
  apiCall({ ...myDonations.requestRefund })
    .then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const makeAnonymous = (entityId, orderId, body) => new Promise((resolve, reject) => {
  myDonations.makeAnonymous.entityId = entityId;
  myDonations.makeAnonymous.orderId = orderId;
  myDonations.makeAnonymous.body = body;
  apiCall({ ...myDonations.makeAnonymous })
    .then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const turnOffGiving = (subId) => new Promise((resolve, reject) => {
  dashboard.turnOffGiving.subId = subId;
  apiCall({ ...dashboard.turnOffGiving })
    .then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const exploreData = (ku) => new Promise((resolve, reject) => {
  explore.ku = ku;
  apiCall({ ...explore })
    .then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const trendingData = (ku) => new Promise((resolve, reject) => {
  explore.ku = ku;
  apiCall({ ...trending })
    .then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const featuredCampaignsData = () => new Promise((resolve, reject) => {
  apiCall({ ...featuredCampaigns })
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    });
});

export const onDemandSubscription = (entityId, reqData) => new Promise((resolve, reject) => {
  onDemandSub.entityId = entityId;
  onDemandSub.body = reqData;
  apiCall({ ...onDemandSub })
    .then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
    })
    .catch((err) => {
      reject(err);
    });
});

export const multiCauseSubs = (entityId, currency, context, setContext) => new Promise((resolve, reject) => {
  if (context.length == 0) {
    multiCause.entityId = entityId;
    multiCause.currency = currency;
    apiCall({ ...multiCause })
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem('multiArray', JSON.stringify(res.data.data));
          setContext(res.data.data);
          resolve(res.data.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    localStorage.setItem('multiArray', JSON.stringify(context));
    resolve(context);
  }
});

export const getSuccessStories = () => new Promise((resolve, reject) => {
  apiCall({ ...successStories })
    .then((res) => {
      if (res.status === 200) {
        resolve(res.data);
      }
    })
    .catch((err) => {
      reject(err);
    });
});
